module.exports = __webpack_public_path__ + "img/partner-2.97fe2b45.png";